"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _constants = require("../../constants");

const Tooltip = (0, _core.withStyles)(() => ({
  tooltip: {
    lineHeight: '17.6px',
    fontSize: _constants.fontSizes.detail2,
    padding: '5px 10px 6px 10px'
  }
}))(_core.Tooltip);
var _default = Tooltip;
exports.default = _default;